/**
 * Video Overlay Utility using GLightbox
 * Finds YouTube and Vimeo links and opens them in GLightbox for autoplay with sound
 */

import GLightbox from 'glightbox';

export const videoOverlay = () => {

    const videoLinks = document.querySelectorAll('a[href*="youtube.com"], a[href*="youtu.be"], a[href*="vimeo.com"]');

    // Check if GLightbox is available
    if (typeof GLightbox === 'undefined' || videoLinks.length === 0) {
        console.warn('Video Overlay: GLightbox is required. Please install via npm: npm install glightbox');
        return;
    }

    videoLinks.forEach(link => {
        link.classList.add('glightbox');
    });

    console.log(videoLinks);

    const lightbox = GLightbox({
        touchNavigation: true,
        keyboardNavigation: true,
        closeOnOutsideClick: true,
        autoplayVideos: true,
        openEffect: 'fade',
        closeEffect: 'fade',
        preloadImages: 'visible',
        closeOnOutsideClick: true,
        closeOnEsc: true,
        closeOnScroll: true,
    });

}